import { useEffect, useState } from "react";
import { API } from "../../../utils/api";

const useUsersOptions = (enabled = true) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (!enabled) return;
    API.getAdminUserList({ page: 1, limit: 100 })
      .then((res) => {
        if (res && res.type === "success" && Array.isArray(res.data)) {
          setOptions(
            res.data.map((u) => ({
              id: u.id,
              label: u.name || u.email || u.id,
            })),
          );
        }
      })
      .catch(() => {});
  }, [enabled]);

  return options;
};

export default useUsersOptions;
